import {
  AppUser,
  Branch,
  Category,
  Location,
  Supplier,
  UnitOfMeasure
} from '../models/settings.models';

export const MOCK_BRANCHES: Branch[] = [
  { id: '1', code: 'JHB-HQ', name: 'Johannesburg HQ', city: 'Johannesburg', status: 'active' },
  { id: '2', code: 'SDT-01', name: 'Sandton Branch', city: 'Sandton', status: 'active' },
  { id: '3', code: 'PTA-01', name: 'Pretoria Branch', city: 'Pretoria', status: 'active' }
];

export const MOCK_LOCATIONS: Location[] = [
  { id: '1', code: 'WH-A', name: 'Warehouse A', branchId: '1', type: 'warehouse', status: 'active' },
  { id: '2', code: 'WH-B', name: 'Warehouse B', branchId: '1', type: 'warehouse', status: 'active' },
  { id: '3', code: 'GRG-B', name: 'Garage B', branchId: '1', type: 'garage', status: 'active' },
  { id: '4', code: 'SDT-ST', name: 'Sandton Store', branchId: '2', type: 'store', status: 'active' }
];

export const MOCK_CATEGORIES: Category[] = [
  { id: '1', code: 'PPE', name: 'PPE', description: 'Personal protective equipment', status: 'active' },
  { id: '2', code: 'TOOL', name: 'Tools', description: 'Hand and power tools', status: 'active' },
  { id: '3', code: 'AV', name: 'AV Equipment', description: 'Audio visual rental equipment', status: 'active' },
  { id: '4', code: 'OFF', name: 'Office Supplies', description: 'Stationery and office consumables', status: 'active' },
  { id: '5', code: 'FUR', name: 'Furniture', description: 'Furniture and fixtures', status: 'active' },
  { id: '6', code: 'IT', name: 'IT Hardware', description: 'Computers and networking', status: 'active' },
  { id: '7', code: 'CLN', name: 'Consumables', description: 'Cleaning and general consumables', status: 'active' }
];

export const MOCK_UNITS: UnitOfMeasure[] = [
  { id: '1', code: 'UNIT', name: 'Unit', abbreviation: 'ea', status: 'active' },
  { id: '2', code: 'SET', name: 'Set', abbreviation: 'set', status: 'active' },
  { id: '3', code: 'BOX', name: 'Box', abbreviation: 'box', status: 'active' },
  { id: '4', code: 'KIT', name: 'Kit', abbreviation: 'kit', status: 'active' }
];

export const MOCK_SUPPLIERS: Supplier[] = [
  {
    id: '1',
    code: 'SUP-001',
    name: 'Industrial Supplies SA',
    contactPerson: 'Linda van Wyk',
    email: 'orders@industrialsupplies.co.za',
    phone: '+27 11 555 0101',
    status: 'active'
  },
  {
    id: '2',
    code: 'SUP-002',
    name: 'AV Pro Distributors',
    contactPerson: 'James Khumalo',
    email: 'sales@avpro.co.za',
    phone: '+27 11 555 0202',
    status: 'active'
  },
  {
    id: '3',
    code: 'SUP-003',
    name: 'Office World',
    contactPerson: 'Thandi Nkosi',
    email: 'accounts@officeworld.co.za',
    phone: '+27 11 555 0303',
    status: 'active'
  }
];

export const MOCK_USERS: AppUser[] = [
  {
    id: '1',
    name: 'Tshepo Selomo',
    email: 'tsheposelomo5405@gmail.com',
    role: 'Inventory Manager',
    branch: 'Johannesburg HQ',
    status: 'active'
  },
  {
    id: '2',
    name: 'Sarah Mokoena',
    email: 'sarah.mokoena@ims.co.za',
    role: 'Warehouse Supervisor',
    branch: 'Johannesburg HQ',
    status: 'active'
  }
];
